import {
  default as authSelector,
  default as corporateSelector,
} from 'modules/Auth/selectors'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import corporateRequest from 'utils/corporateRequest'
import instituteRequest from 'utils/instituteRequest'
import request from 'utils/request'
import studentRequest from 'utils/studentRequest'

export const SET_DRIVE_METRICS = 'corporate/SET_DRIVE_METRICS'
export const SET_DRIVE_ROLES_METRICS = 'corporate/SET_DRIVE_ROLES_METRICS'
export const SET_ROLE_METRICS = 'corporate/SET_ROLE_METRICS'
export const SET_APPLICANT_METRICS = 'corporate/SET_APPLICANT_METRICS'
export const SET_DRIVE_DATA = 'corporate/SET_DRIVE_DATA'
export const SET_INTERVIEWR_LIST = 'corporate/SET_INTERVIEWR_LIST'
export const SET_DRIVE_INTERVIEWR_LIST = 'corporate/SET_DRIVE_INTERVIEWR_LIST'
export const SET_DEGREE_LIST = 'corporate/SET_DEGREE_LIST'
export const SET_COLLEGE_LIST = 'corporate/SET_COLLEGE_LIST'
export const SET_CANDIDATE_INTERVIEW_DETAILS =
  'corporate/SET_CANDIDATE_INTERVIEW_DETAILS'
export const SET_GROUP_LIST = 'corporate/SET_GROUP_LIST'
export const SET_GROUP_CANDIDATE__LIST = 'corporate/SET_GROUP_CANDIDATE__LIST'
export const SET_CITY_LIST = 'corporate/SET_CITY_LIST'
export const SET_RECREATE = 'corporate/SET_RECREATE'
export const SET_ROLES_ROUNDS = 'corporate/SET_ROLES_ROUNDS'
export const SET_INTERVIEWR_LOCATION = 'coporate/SET_INTERVIEWR_LOCATION'
export const SET_CANDIDATE_DOCUMENTS_LIST =
  'coporate/SET_CANDIDATE_DOCUMENTS_LIST'
export const SET_CANDIDATE_DOCUMENTS_METRICES =
  'coporate/SET_CANDIDATE_DOCUMENTS_METRICES'

export const SET_CANDIDATE_SCORE_LIST = `SET_CANDIDATE_SCORE_LIST`

export const SET_REQUEST_DOCUMENTATION = 'corporate/SET_REQUEST_DOCUMENTATION'

export const SET_RESCHEDULE_LIST = 'corporate/SET_RESCHEDULE_LIST'

export const setRequestDocument = data => {
  return {
    type: SET_REQUEST_DOCUMENTATION,
    data,
  }
}
export const setCandidateScoreList = data => {
  return {
    type: SET_CANDIDATE_SCORE_LIST,
    data,
  }
}
export const setDriveMetrics = data => {
  return {
    type: SET_DRIVE_METRICS,
    data,
  }
}
export const setDriveRolesMetrics = data => {
  return {
    type: SET_DRIVE_ROLES_METRICS,
    data,
  }
}
export const setRoleRounds = data => {
  return {
    type: SET_ROLES_ROUNDS,
    data,
  }
}

export const setRoleMetrics = data => {
  return {
    type: SET_ROLE_METRICS,
    data,
  }
}

export const setApplicantMetrics = data => {
  return {
    type: SET_APPLICANT_METRICS,
    data,
  }
}

export const setDrivesData = data => {
  return {
    type: SET_DRIVE_DATA,
    data,
  }
}

export const setInterviewerList = data => {
  return {
    type: SET_INTERVIEWR_LIST,
    data,
  }
}

export const setDriveInterviewerList = data => {
  return {
    type: SET_DRIVE_INTERVIEWR_LIST,
    data,
  }
}

export const setDegreeList = data => {
  return {
    type: SET_DEGREE_LIST,
    data,
  }
}

export const setCollegeList = data => {
  return {
    type: SET_COLLEGE_LIST,
    data,
  }
}

export const setCandidateInterviewDetails = data => {
  return {
    type: SET_CANDIDATE_INTERVIEW_DETAILS,
    data,
  }
}

export const setGroupList = data => {
  return {
    type: SET_GROUP_LIST,
    data,
  }
}

export const setGroupCandidateList = data => {
  return {
    type: SET_GROUP_CANDIDATE__LIST,
    data,
  }
}

export const setCityList = data => {
  return {
    type: SET_CITY_LIST,
    data,
  }
}
export const setRecreate = data => {
  return {
    type: SET_RECREATE,
    data,
  }
}

export const setInterViewLocation = data => {
  return {
    type: SET_INTERVIEWR_LOCATION,
    data,
  }
}

export const setCandidateDocumentsList = data => {
  return {
    type: SET_CANDIDATE_DOCUMENTS_LIST,
    data,
  }
}

export const setRescheduleList = data => {
  return {
    type: SET_RESCHEDULE_LIST,
    data,
  }
}

export const setCandidateDocumentsMetrices = data => {
  return {
    type: SET_CANDIDATE_DOCUMENTS_METRICES,
    data,
  }
}

export const getDriveListData =
  ({
    currentPage,
    searchValue,
    corporateStatus,
    occurrence,
    driveRoles,
    driveMode,
    driveStatus,
    sortBy,
    driveStartDate,
    driveEndDate,
    pageLimit,
    roleId,
  }) =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const coporateId = corporateSelector.getCorporateId(state)
      const search = searchValue ? `&searchBy=${searchValue.trim()}` : ''
      const ongoingStatus = corporateStatus
        ? `&corporateStatus=${corporateStatus}`
        : ''
      const role = driveRoles?.length > 0 ? `&roles=${driveRoles}` : ''
      const mode = `&driveMode=${'EXP_CANDIDATE_DRIVE'}`
      const status =
        driveStatus?.length > 0 ? `&corporateStatus=${driveStatus}` : ''

      const sortKey = sortBy?.columnKey ? `&sort=${sortBy?.columnKey}` : ''
      const order = sortBy?.order === 'ascend' ? 'asc' : 'desc'
      const sortOrder = sortBy?.order ? `&orderBy=${order}` : ''
      const startDate = driveStartDate ? `&postedOnStart=${driveStartDate}` : ''
      const endDate = driveEndDate ? `&postedOnEnd=${driveEndDate}` : ''
      const rolekey = roleId ? `&roles=${roleId}` : ''

      const response = await corporateRequest.get(
        `corporates/${coporateId}/expstudent/jobs/lists?pageLimit=${
          pageLimit || 10
        }&pageNo=${currentPage}${search}${ongoingStatus}${role}${mode}${status}${sortKey}${sortOrder}${startDate}${endDate}${rolekey}`
      )
      return response
    } catch (error) {
      return error
    }
  }

export const getIndidualDriveMetrics = driveId => async dispatch => {
  try {
    const response = await corporateRequest.get(
      `/corporates/${driveId}/metrics`
    )
    dispatch(setDriveMetrics(response?.data?.data || {}))
    return response
  } catch (error) {
    return error
  }
}

export const getRequestDocument = roleId => async dispatch => {
  try {
    const response = await studentRequest.get(`students/documents/list`)
    dispatch(setRequestDocument(response?.data?.data || []))
    return response
  } catch (error) {
    return error
  }
}

export const getDriveRoleMetrics = driveId => async dispatch => {
  try {
    const mode = `?driveMode=${'EXP_CANDIDATE_DRIVE'}`
    const response = await corporateRequest.get(
      `/corporates/${driveId}/roles/metrics${mode}`
    )
    dispatch(setDriveRolesMetrics(response?.data?.data || {}))
    return response
  } catch (error) {
    return error
  }
}
export const getRoleRounds = roleId => async dispatch => {
  try {
    const response = await corporateRequest.get(
      `/corporates/role/${roleId}/expstudent/interview/rounds`
    )
    dispatch(setRoleRounds(response?.data?.data?.rounds || []))
    return response
  } catch (error) {
    return error
  }
}

export const getRoleMetrics =
  (driveId, roleIdValue = '') =>
  async dispatch => {
    try {
      const response = await corporateRequest.get(
        `/corporates/drive/${driveId}/role/${roleIdValue}/metrics`
      )
      dispatch(setRoleMetrics(response?.data?.data || {}))
    } catch (error) {
      return error
    }
  }

export const getApplicantMetrics =
  ({ roleId }) =>
  async dispatch => {
    try {
      const response = await corporateRequest.get(
        `/corporates/roles/${roleId}/metrix`
      )
      dispatch(setApplicantMetrics(response?.data?.data || {}))
    } catch (error) {
      //
    }
  }

export const getIndidualDriveData = jobId => async (dispatch, getState) => {
  const state = getState()
  const coporateId = corporateSelector.getCorporateId(state)
  try {
    const response = await corporateRequest.get(
      `corporates/${coporateId}/expstudent/job/${jobId}`
    )
    dispatch(setDrivesData(response?.data?.data))
    return response
  } catch (error) {
    return error
  }
}

export const getRoleList = currentPage => async (dispatch, getState) => {
  const state = getState()
  const coporateId = corporateSelector.getCorporateId(state)
  try {
    const response = await corporateRequest.get(
      `corporates/${coporateId}/jobs/lists?pageLimit=10&pageNo=${
        currentPage || 0
      }`
    )
    return response
  } catch (error) {
    return error
  }
}


export const getInterviewerList =
  (searchValue, driveId) => async (dispatch, getState) => {
    try {
      const state = getState()
      const corporate_id = authSelector.getCorporateId(state)
      const search = searchValue ? `&search=${searchValue.trim()}` : ''
      const response = await corporateRequest.get(
        `/corporates/drive/${driveId}/interviewer/replace?currentPage=1&pageLimit=500&corporateId=${corporate_id}${search}`
      )
      dispatch(setInterviewerList(response?.data?.data || []))

      return response
    } catch (error) {
      return error
    }
  }

export const getDriveInterviewerList = driveId => async dispatch => {
  try {
    const response = await corporateRequest.get(
      `/corporates/drive/${driveId}/interviewer/list`
    )
    dispatch(setDriveInterviewerList(response?.data?.data?.interviewere || []))
    return response
  } catch (error) {
    return error
  }
}

export const addInterviewer = (driveId, interviewId, payLoad) => async () => {
  try {
    const response = await corporateRequest.post(
      `/corporates/drive/${driveId}/addInterviewer/${interviewId}`,
      payLoad
    )
    return response
  } catch (error) {
    return error
  }
}

export const deleteInterviewer = (driveId, payload) => async () => {
  try {
    const response = await corporateRequest.delete(
      `/corporates/drive/${driveId}/deleteInterviewer`,
      { data: payload }
    )
    return response
  } catch (error) {
    return error
  }
}

export const updateRoleRounds = (driveId, roleId, payload) => async () => {
  try {
    const response = await corporateRequest.put(
      `/corporates/drive/${driveId}/role/${roleId}/expstudent/interview/rounds`,
      payload
    )
    return response
  } catch (error) {
    return error
  }
}

export const requestCandidateDocuments =
  (driveId, roleId, payload) => async (dispatch, getState) => {
    try {
      const state = getState()
      const corporateId = authSelector.getCorporateId(state)
      const response = await corporateRequest.post(
        `/corporates/${corporateId}/drive/${driveId}/role/${roleId}/reqDocs`,
        payload
      )
      return response
    } catch (error) {
      return error
    }
  }
export const postShortlistCandidates = (extAssmntId, payload) => async () => {
  try {
    const response = await corporateRequest.post(
      `/corporates/extAssment/${extAssmntId}/candidate/shortlist`,
      payload
    )
    return response
  } catch (error) {
    return error
  }
}
const getOfferStatus = status => {
  if (status === 'SCHEDULED,SHORTLISTED,PENDING,REJECTED') {
    return 'NOT_RELEASED'
  } else if (status === 'HOLD') {
    return 'RELEASED'
  } else if (status === 'REJECTED') {
    return 'REJECTED'
  } else if (status === 'ACCEPTED') {
    return 'ACCEPTED'
  } else if (status === 'NEGOTIATED') {
    return 'NEGOTIATED'
  } else if (status === 'JOINED') {
    return 'JOINED'
  }
}

export const getDriveRoleCandidatesList =
  ({
    driveId,
    roleId,
    currentPage,
    searchValue,
    sortBy,
    status,
    stage,
    candidateRating,
    checkedIds,
    college,
    rolesMetrics,
  }) =>
  async () => {
    try {
      const search = searchValue ? `&searchBy=${searchValue.trim()}` : ''
      const sortKey = sortBy?.columnKey ? `&sort=${sortBy?.columnKey}` : ''
      const order = sortBy?.order === 'ascend' ? 'asc' : 'desc'
      const sortOrder = sortBy?.order ? `&order=${order}` : ''
      const candidateStatus = status
        ? `&status=${
            stage === 'offer' || status === 'NEGOTIATED'
              ? 'SELECTED'
              : stage === 'all_candidates'
              ? status === 'SCHEDULED,SHORTLISTED,PENDING,REJECTED'
                ? 'SCHEDULED,SHORTLISTED,SELECTED,PENDING,REJECTED'
                : status
              : status
          }`
        : ''

      const stageValue =
        stage !== 'all_candidates' && stage !== 'offer'
          ? `&stages=${stage}`
          : stage === 'offer'
          ? `&stages=${
              rolesMetrics[0]?.rounds[rolesMetrics[0]?.rounds?.length - 2]
                ?.roundName
            }`
          : ''

      let rate = candidateRating?.minValue?.toString()
        ? `&fromRating=${candidateRating?.minValue?.toString()}`
        : ''
      let maxRate = candidateRating?.maxValue?.toString()
        ? `&toRating=${candidateRating?.maxValue?.toString()}`
        : ''
      const degree =
        checkedIds?.length > 0 ? `&degreeStreamMapIds=${checkedIds}` : ''
      const collegeValue = college?.length > 0 ? `&collegeName=${college}` : ''
      const offerStatus = getOfferStatus(status)
      const offer =
        stage === 'offer' || offerStatus === 'NEGOTIATED'
          ? `&offerStatus=${offerStatus}`
          : ''
      const response = await studentRequest.get(
        `students/drive/${driveId}/role/${roleId}/ExpCandidate/list?pageLimit=10&pageNo=${currentPage}${search}${sortKey}${sortOrder}${candidateStatus}${stageValue}${rate}${maxRate}${degree}${collegeValue}${offer}`
      )

      return response
    } catch (error) {
      return error
    }
  }

export const getDegreeAndDepartMent = roleId => async dispatch => {
  try {
    const response = await corporateRequest.get(
      `/corporate/role/${roleId}/degree`
    )
    dispatch(setDegreeList(response?.data?.data || []))
    return response
  } catch (error) {
    return error
  }
}

export const getcollegeList = (driveId, roleId, search) => async dispatch => {
  try {
    let searchValue = search ? `?search=${search.trim()}` : ''
    const response = await instituteRequest.get(
      `institutes/instituteCampus/drive/${driveId}/role/${roleId}/list${searchValue}`
    )
    dispatch(setCollegeList(response?.data?.data || []))
    return response
  } catch (error) {
    return error
  }
}

export const createInterview = (driveId, roleId, payload) => async () => {
  try {
    const response = await corporateRequest.post(
      `corporates/role/${roleId}/drive/${driveId}/setInterview`,
      payload
    )
    return response
  } catch (error) {
    return error
  }
}

export const downloadCandidate =
  (driveId, roleId, selectedFileType, selectedRound, selectedColumn) =>
  async () => {
    try {
      const round = selectedRound ? `&stage=${selectedRound}` : ''
      const key =
        selectedColumn?.length > 0 ? `&key=${selectedColumn.join(',')}` : ''

      const response = await studentRequest.get(
        `students/drive/${driveId}/list?roleId=${roleId}&type=${selectedFileType}${round}${key}`
      )
      return response
    } catch (error) {
      return error
    }
  }

export const addTimeBreak = (driveId, payload) => async () => {
  try {
    const response = await corporateRequest.put(
      `/corporates/drive/${driveId}/addBreak`,
      payload
    )
    return response
  } catch (error) {
    return error
  }
}

export const getSingleCandidateInterviewDetails =
  (roleId, driveId, studentId) => async dispatch => {
    try {
      const response = await corporateRequest.get(
        `/corporates/role/${roleId}/drive/${driveId}/student/${studentId}/interview`
      )
      dispatch(setCandidateInterviewDetails(response?.data?.data))
      return response
    } catch (error) {
      return error
    }
  }

export const getGroupDiscussionList =
  (roleId, driveId, interviewRound, status, currentPage = 0) =>
  async dispatch => {
    try {
      const groupStatus = status ? `&status=${status}` : ''
      const response = await corporateRequest.get(
        `/corporates/role/${roleId}/drive/${driveId}/groupDiscussionList/${decodeURIComponent(
          interviewRound
        )}?pageLimit=5&currentPage=${Number(currentPage) + 1}${groupStatus}`
      )
      dispatch(setGroupList(response?.data?.data))
      return response
    } catch (error) {
      return error
    }
  }

export const getGroupCandidateList =
  (roleId, driveId, interviewId, groupId, status, stage) => async dispatch => {
    try {
      const candidateStatus = status ? `?status=${status}` : ''
      const stageValue = stage ? `&stage=${stage}` : ''
      const response = await corporateRequest.get(
        `/corporates/role/${roleId}/drive/${driveId}/interview/${interviewId}/group/${groupId}/groupCandidateList${candidateStatus}${stageValue}`
      )
      dispatch(setGroupCandidateList(response?.data?.data))
      return response
    } catch (error) {
      return error
    }
  }

export const updateInterviewStatus = (driveId, roleId, payload) => async () => {
  try {
    const response = await corporateRequest.post(
      `corporates/role/${roleId}/drive/${driveId}/updateStatus`,
      payload
    )
    return response
  } catch (error) {
    return error
  }
}

export const getCities =
  ({ searchValue }) =>
  async dispatch => {
    let SearchKey = searchValue ? `&search=${searchValue?.trim()}` : ''
    try {
      const result = await request.get(
        `cities?pageLimit=50&currentPage=1${SearchKey}`
      )
      dispatch(setCityList(result?.data?.data))
      return result
    } catch (error) {
      dispatch(setCityList([]))
    }
  }

export const releaseOfferAPI = (driveId, roleId, payload) => async () => {
  try {
    const response = await corporateRequest.post(
      `corporates/role/${roleId}/drive/${driveId}/realeaseOffer`,
      payload
    )
    return response
  } catch (error) {
    return error
  }
}

export const downloadCandidateList =
  (driveId, roleId, selectedRound, payload) => async () => {
    try {
      const response = await studentRequest.post(
        `students/role/${roleId}/drive/${driveId}/interview/candidateListFileForUploadResult?type=xlsx`,
        payload
      )
      return response
    } catch (error) {
      return error
    }
  }

export const uploadResultAPI = (driveId, roleId, payload) => async () => {
  try {
    const response = await corporateRequest.post(
      `corporates/role/${roleId}/drive/${driveId}/bulkResultUpload`,
      payload
    )

    return response
  } catch (error) {
    return error
  }
}

export const getInstituteData = instituteCampusId => async () => {
  try {
    const response = await instituteRequest.get(
      `/institutes/instituteCampus/${instituteCampusId}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const recreateCall = (driveId, payload, status) => async () => {
  try {
    const response = await corporateRequest.post(
      `/corporates/virtualDrive/${driveId}/recreate`,
      payload
    )
    if (response?.status == 200) {
      status('Success')
      SuccessMessage('Updated Successfully')
    }
    return response
  } catch (error) {
    status('FAILURE')
    ErrorMessage('Recreation Failed!')
    return error
  }
}

export const getExpDriveListData =
  ({
    currentPage,
    searchValue,
    corporateStatus,
    occurrence,
    driveRoles,
    driveMode,
    roleId,
    driveStatus,
    sortBy,
    driveStartDate,
    driveEndDate,
    pageLimit,
  }) =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const coporateId = corporateSelector.getCorporateId(state)
      const search = searchValue ? `&search=${searchValue?.trim()}` : ''
      const ongoingStatus = corporateStatus
        ? `&corporateStatus=${corporateStatus}`
        : ''
      const role = driveRoles?.length > 0 ? `&roles=${driveRoles}` : ''
      const status =
        driveStatus?.length > 0 ? `&corporateStatus=${driveStatus}` : ''

      const sortKey = sortBy?.columnKey ? `&sort=${sortBy?.columnKey}` : ''
      const order = sortBy?.order === 'ascend' ? 'asc' : 'desc'
      const sortOrder = sortBy?.order ? `&order=${order}` : ''
      const startDate = driveStartDate
        ? `&driveStartDate=${driveStartDate}`
        : ''
      const endDate = driveEndDate ? `&driveEndDate=${driveEndDate}` : ''

      const response = await corporateRequest.get(
        `/corporates/${coporateId}/role/${roleId}/drive/list?pageLimit=${
          pageLimit || 10
        }&currentPage=${currentPage}${search}${ongoingStatus}${role}${status}${sortKey}${sortOrder}${startDate}${endDate}`
      )
      return response
    } catch (error) {
      return error
    }
  }
export const updateInterview =
  (driveId, interviewerId, payload) => async () => {
    try {
      const response = await corporateRequest.put(
        `corporates/drive/${driveId}/interviewer/${interviewerId}`,
        payload
      )

      return response
    } catch (error) {
      return error
    }
  }

export const getInterViewLocation =
  (currentPage, pageLimit) => async (dispatch, getState) => {
    try {
      const state = getState()
      const coporateId = corporateSelector.getCorporateId(state)
      const response = await corporateRequest.get(
        `/corporates/${coporateId}/branch?pageLimit=${pageLimit || 10}`
      )
      dispatch(setInterViewLocation(response?.data?.data))
      return response
    } catch (error) {
      return error
    }
  }

export const getCandidateDocumentsList =
  ({
    roleId,
    driveId,
    searchValue,
    sortby,
    orderby,
    currentPage,
    documentType,
  }) =>
  async (dispatch, getState) => {
    try {
      const search = searchValue ? `&searchBy=${searchValue?.trim()}` : ''
      let sort = sortby ? `&sort=${sortby}` : ''
      let orderBy = orderby ? `&orderBy=${orderby}` : ''
      const doc_type = documentType ? `&doc_type=${documentType}` : ''
      const state = getState()
      const corporateId = authSelector.getCorporateId(state)
      const response = await studentRequest.get(
        `/students/corporate/${corporateId}/drive/${driveId}/role/${roleId}/reqDoc/list?pageLimit=10&pageNo=${currentPage}${search}${sort}${orderBy}${doc_type} `
      )
      dispatch(setCandidateDocumentsList(response?.data?.data))
      return response
    } catch (error) {
      return error
    }
  }

export const getCandidateDocumentsMetrices =
  (roleId, driveId, corporateId) => async (dispatch, getState) => {
    try {
      const state = getState()
      const corporateId = authSelector.getCorporateId(state)
      const response = await studentRequest.get(
        `/students/corporate/${corporateId}/drive/${driveId}/role/${roleId}/reqDoc/metrices`
      )
      dispatch(setCandidateDocumentsMetrices(response?.data?.data))
      return response
    } catch (error) {
      return error
    }
  }

export const getCandidateScoreList =
  ({
    driveId,
    roleId,
    currentPage,
    searchValue,
    sortBy,
    status,
    stage,
    candidateRating,
    checkedIds,
    college,
    rolesMetrics,
    topicsPayload,
    filter,
  }) =>
  async () => {
    try {
      const search = searchValue ? `&search=${searchValue}` : ''
      const sortKey = sortBy?.field
        ? sortBy?.field == 'firstName'
          ? `&sort=${sortBy?.field}`
          : `&topicId=${sortBy?.field}`
        : ``
      const order = sortBy?.order === 'ascend' ? 'asc' : 'desc'
      const sortOrder = sortBy?.order ? `&order=${order}` : ''
      const candidateStatus =
        filter && filter?.length > 0
          ? `&status=${filter?.join(',')}`
          : status
          ? `&status=${
              stage === 'offer' || status === 'NEGOTIATED'
                ? 'SELECTED'
                : stage === 'all_candidates'
                ? status === 'SCHEDULED,SHORTLISTED,PENDING'
                  ? 'SCHEDULED,SHORTLISTED,SELECTED,PENDING'
                  : status
                : status
            }`
          : ''

      const stageValue =
        stage !== 'all_candidates' && stage !== 'offer'
          ? `&stages=${stage}`
          : stage === 'offer'
          ? `&stages=${
              rolesMetrics[0]?.rounds[rolesMetrics[0]?.rounds?.length - 2]
                ?.roundName
            }`
          : ''
      const rating =
        candidateRating?.length > 0 ? `&rating=${candidateRating}` : ''
      const degree =
        checkedIds?.length > 0 ? `&degreeStreamMapIds=${checkedIds}` : ''
      const collegeValue = college?.length > 0 ? `&collegeName=${college}` : ''
      const offerStatus = getOfferStatus(status)
      const payload =
        topicsPayload?.scores?.filter(topic => Number(topic?.score) > 0) || []
      const updatedData = { scores: payload }
      const offer =
        stage === 'offer' || offerStatus === 'NEGOTIATED'
          ? `&offerStatus=${offerStatus}`
          : ''
      const response = await studentRequest.post(
        `students/drive/${driveId}/role/${roleId}/driveCandidate/list?pageLimit=10&pageNo=${currentPage}${search}${sortKey}${sortOrder}${candidateStatus}${stageValue}${rating}${degree}${collegeValue}${offer}`,
        updatedData
      )

      return response
    } catch (error) {
      return error
    }
  }
export const getTopicsList = (extAssmntId, param) => async dispatch => {
  try {
    const response = await corporateRequest.get(
      `/corporates/extAssessment/${extAssmntId}/topics/list`
    )
    dispatch(setCandidateScoreList(response?.data))
    return response
  } catch (error) {
    return error
  }
}

export const postPassingScore = payload => async () => {
  try {
    const response = await corporateRequest.post(
      `/corporates/extAssmnt/updatePassingScore`,
      payload
    )
    return response
  } catch (error) {
    return error
  }
}

// Invite Candidates Actions
export const bulkUploadInviteCandidates = (jobId, payload) => async () => {
  try {
    const response = await corporateRequest.post(
      `/corporates/job/${jobId}/inviteCandidates/bulkUpload`,
      payload
    )
    return response
  } catch (error) {
    return error
  }
}

// "Mark as applied" path: writes a versioned Google Sheet only — no email/WA, no DB candidate marking.
export const bulkUploadAppliedCandidates = (jobId, payload) => async () => {
  try {
    const response = await corporateRequest.post(
      `/corporates/job/${jobId}/appliedCandidates/bulkUpload`,
      payload
    )
    return response
  } catch (error) {
    return error
  }
}

export const getInviteCandidates =
  (jobId, params) => async (dispatch) => {
    try {
      const response = await corporateRequest.get(
        `/corporates/job/${jobId}/inviteCandidates`,
        { params }
      )
      return response
    } catch (error) {
      return error
    }
  }

export const getInviteCandidatesCount = jobId => async () => {
  try {
    const response = await corporateRequest.get(
      `/corporates/job/${jobId}/inviteCandidates/count`
    )
    return response
  } catch (error) {
    return error
  }
}

